import {
  selectIsAdmin,
  selectLoggedInEmplid,
} from "../../services/authorization/slices";
import { syncAuthState } from "../../services/authorization/thunks";
import {
  selectDataGrid,
  setFilterModel,
  setNextIDs,
  setReferenceMap,
  setSortModel,
} from "../../services/form/slices";

const CACHE_KEY = "submissionsDataGridState";
const CACHE_DURATION = 28 * 24 * 60 * 60 * 1000;

const saveToCache = (filterModel, sortModel, cachedNextIds = {}) => {
  const sensitive = ["osuUniqueID", "nameN", "emplid"]
  const filterModelToCache = {
    ...filterModel,
    items: filterModel
      .items
      .filter((item) => !sensitive.includes(item.field))
      .map(({ field, operator, value }) => ({ field, operator, value })),
  };
  const state = { filterModel: filterModelToCache, sortModel, timestamp: Date.now(), ...cachedNextIds };
  localStorage.setItem(CACHE_KEY, JSON.stringify(state));
};

const loadFromCache = () => {
  try {
    const cached = localStorage.getItem(CACHE_KEY);
    if (!cached) return null;
    const state = JSON.parse(cached);
    return Date.now() - state.timestamp > CACHE_DURATION ? null : state;
  } catch {
    return null;
  }
};

export const createCacheMiddleware =
  ({ dispatch, getState }) =>
  (next) =>
  (action) => {
    const result = next(action);
    if (setFilterModel.match(action) || setSortModel.match(action) || setNextIDs.match(action)) {
      const currentState = getState()
      const dataGrid = selectDataGrid(currentState);
      const isAdmin = selectIsAdmin(currentState);
      const cachedNextIds = {
        ids: dataGrid.ids,
        referenceMap: dataGrid.referenceMap
      }
      const storeNext = isAdmin && cachedNextIds?.ids?.length && Object.keys(cachedNextIds.referenceMap).length
      saveToCache(dataGrid.filterModel, dataGrid.sortModel, storeNext && cachedNextIds);
    }

    if (syncAuthState.fulfilled.match(action)) {
      const isAdmin = selectIsAdmin(getState());
      const emplid = selectLoggedInEmplid(getState());
      const cached = loadFromCache();
      const sortModel = cached?.sortModel || [
        { field: "foreignSourceName", sort: "asc" },
      ];
      const cachedFilterModel = cached?.filterModel || {
        items: [],
      };
      if (cachedFilterModel?.items?.length) {
        cachedFilterModel.items = cachedFilterModel.items.filter(
          (item) => item.field !== "emplid"
        );
      } else {
        cachedFilterModel.items = [];
      }
      if (!isAdmin && emplid) {
        cachedFilterModel.items.push({
          field: "emplid",
          operator: "equals",
          value: emplid,
        });
      }

      dispatch(setFilterModel(cachedFilterModel));
      dispatch(setSortModel(sortModel));
      if(cached?.ids && cached?.referenceMap) {
        dispatch(setNextIDs(cached.ids))
        dispatch(setReferenceMap(cached.referenceMap))
      }
    }

    return result;
  };
